import { createBrowserRouter } from "react-router-dom";

import {
  AdminBrands,
  AdminCatalogueForm,
  AdminCatalouge,
  AdminChangePassword,
  AdminContactMessages,
  AdminDashboard,
  AdminFarmerDetails,
  AdminFarmerList,
  AdminFarmerNotice,
  AdminFarmerStaffDetails,
  AdminHatchery,
  AdminList,
  AdminMarket,
  AdminNotice,
  AdminOrderEnquiry,
  AdminOrderNotice,
  AdminPage,
  AdminPages,
  AdminProfile,
  AdminRegisterNotice,
  AdminResources,
  AdminScheduleNotice,
  AdminSiteSettings,
  AdminUnVerify,
  AdminUnverfiyDetails,
  AdminVerfiyDetails,
  AdminVerify,
  AdminVerifyDailyInputs,
  AdminVetRoom,
  AdminVetRoomDetails,
  DailyInformation,
  ErrorFallback,
  ExternalDailyInputs,
  ExternalInformation,
  ExternalSuggestion,
  ForgetPassword,
  Home,
  InternalInformation,
  InternalSuggestion,
  Login,
  // not-found
  NotFound,
  Page,

  // admin
  RequireAdmin,
  ResetOtpVerify,
  ResetPassword,
  Root
} from "./imports";

const router = createBrowserRouter([
  {
    path: "",
    element: <Root />,
    errorElement: <ErrorFallback />,
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/forgot-password",
        element: <ForgetPassword />,
      },
      {
        path: "/verify-otp",
        element: <ResetOtpVerify />,
      },
      {
        path: "/reset-password",
        element: <ResetPassword />,
      },
      {
        path: "/external-dailyinputs/daily-information/:id",
        element: <DailyInformation />,
      },
      {
        path: "/external-dailyinputs/checklist/:id",
        element: <ExternalInformation />,
      },
      {
        path: "/external-dailyinputs/suggestion/:id",
        element: <ExternalSuggestion />,
      },
      {
        path: "/external-dailyinputs/checklist2/:id",
        element: <InternalInformation />,
      },
      {
        path: "/external-dailyinputs/suggestion2/:id",
        element: <InternalSuggestion />,
      },
      {
        path: "/external-dailyinputs/form-submit/:id",
        element: <ExternalDailyInputs />,
      },
      {
        path: "privacy-policy",
        element: <Page slug="privacy-policy" />,
      },
      {
        path: "terms-and-conditions",
        element: <Page slug="terms-and-conditions" />,
      },
      {
        path: "admin",
        element: <RequireAdmin />,
        children: [
          {
            path: "",
            element: <AdminDashboard />,
          },
          {
            path: "profile",
            element: <AdminProfile />,
          },
          {
            path: "change-password",
            element: <AdminChangePassword />,
          },
          {
            path: "notice",
            element: <AdminNotice />,
          },
          {
            path: "market",
            element: <AdminMarket />,
          },
          {
            path: "resources",
            element: <AdminResources />,
          },
          {
            path: "vet-room",
            element: <AdminVetRoom />,
          },
          {
            path: "vet-room/create",
            element: <AdminVetRoomDetails />,
          },
          {
            path: "vet-room/:id",
            element: <AdminVetRoomDetails />,
          },
          {
            path: "farmer-notice",
            element: <AdminFarmerNotice />,
          },
          {
            path: "schedule-notice",
            element: <AdminScheduleNotice />,
          },
          {
            path: "register-notice",
            element: <AdminRegisterNotice />,
          },
          {
            path: "order-notice",
            element: <AdminOrderNotice />,
          },
          {
            path: "",
            children: [
              {
                path: "farmers-lot",
                element: <AdminVerify />,
              },
              {
                path: "farmers-lot/:id",
                element: <AdminVerfiyDetails />,
              },
              {
                path: "farmers-lot/daily-inputs",
                element: <AdminVerifyDailyInputs />,
              },
              {
                path: "lot-enquiry",
                element: <AdminUnVerify />,
              },
              {
                path: "lot-enquiry/:id",
                element: <AdminUnverfiyDetails />,
              },
            ],
          },
          {
            path: "contact",
            children: [
              {
                path: "messages",
                element: <AdminContactMessages />,
              },
              {
                path: "order-enquiry",
                element: <AdminOrderEnquiry />,
              },
            ],
          },
          {
            path: "",
            children: [
              {
                path: "admin-list",
                element: <AdminList />,
              },
              {
                path: "farmer-list",
                element: <AdminFarmerList />,
              },
              {
                path: "farmer-list/:id",
                element: <AdminFarmerDetails />,
              },
              {
                path: "farmer-list/staff-assigned",
                element: <AdminFarmerStaffDetails />,
              },
            ],
          },
          {
            path: "misc",
            children: [
              {
                path: "pages",
                element: <AdminPages />,
              },
              {
                path: "pages/:slug",
                element: <AdminPage />,
              },
              {
                path: "brands",
                element: <AdminBrands />,
              },
              {
                path: "hatchery",
                element: <AdminHatchery />,
              },
              {
                path: "catalogue",
                element: <AdminCatalouge />,
              },
              {
                path: "catalogue/:id",
                element: <AdminCatalogueForm />,
              },
              {
                path: "site-setting",
                element: <AdminSiteSettings />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default router;
